
/**
 * @Description //TODO 文件功能说明：全局函数定义
 * @author Zhangbin
 * @date 2021/4/30 16:51
 * @Ver 1.3.1
 * @extends Vue
 */

export default {
    /**
     * @Author ZhangBin
     * @Description //TODO 真实坐标转地图坐标
     * @Date 18:37 2022/8/16
     * @Param mapInfo 地图信息
     * @Param point 实际坐标
     * @Param offsetScaleX 实际坐标偏移量（0-1）
     * @Param offsetScaleX 实际坐标偏移量（0-1）
     * @return
     **/
    realPointToMapPoint: (mapInfo, point, offsetX=0, offsetY=0) =>{
		
        // 初始化值
        let pointPx = {xPx: 0, yPx: 0};

        if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e4'){

            // 实际坐标进行偏移
            point = mapMeterToOffset(mapInfo, point, offsetX, offsetY);

            // 隧道基础版
            pointPx = mapMeterToPx(mapInfo, point);

        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5'){
			
            // 实际坐标进行偏移
            point = mapMeterToOffset(mapInfo, point, offsetX, offsetY);
			
            // 隧道单面版
            pointPx = mapMeterToPx(mapInfo, point);
			
            // 坐标旋转
            pointPx = spinPointToMap(mapInfo, pointPx);
            
        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){

            // 实际坐标进行偏移
            point = mapMeterToOffset(mapInfo, point, offsetX, offsetY);

            // 隧道双面板
            pointPx = mapMeterToPx(mapInfo, point);

            // 坐标旋转
            pointPx = spinPointToMap(mapInfo, pointPx);

        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e7'){
            // 蜂鸟云

        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e2'){
            // 工厂
            
            // 实际坐标进行偏移
            point = mapMeterToOffset(mapInfo, point, offsetX, offsetY);
			
            // 隧道单面版
            pointPx = mapMeterToPx(mapInfo, point);
			
            // 坐标旋转
            pointPx = spinPointToMap(mapInfo, pointPx);

        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e11'){
            // 隧道定制版

            // 隧道实际转像素
            pointPx = customMadeTunnelToPx(mapInfo, point, offsetX);
            if(pointPx == null){
                pointPx = {xPx: 0, yPx: 0};
            }

        }else{
            // 普通版
            pointPx = mapMeterToPx(mapInfo, point);

        }

        // console.log(pointPx)

        return pointPx;
    },

    /**
     * @Author ZhangBin
     * @Description //TODO 地图坐标转真实坐标
     * @Date 18:37 2022/8/16
     * @Param
     * @return
     **/
    mapPointToRealPoint: (mapInfo, pointPx) => {
        // 初始化坐标
        let point = {x: 0, y: 0};

        if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e4'){
            // 隧道基础版
            point = mapPxToMeter(mapInfo, pointPx);

        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5'){
            // 坐标旋转
            pointPx = spinPointToMeter(mapInfo, pointPx);

            // 隧道单面版
            point = mapPxToMeter(mapInfo, pointPx);


        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
            // 坐标旋转
            pointPx = spinPointToMeter(mapInfo, pointPx);

            // 隧道双面板
            point = mapPxToMeter(mapInfo, pointPx);

        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e7'){
            // 蜂鸟云

        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e2'){
            // 工厂
            // 坐标旋转
            pointPx = spinPointToMeter(mapInfo, pointPx);

            point = mapPxToMeter(mapInfo, pointPx);

        }else{
            // 普通版
            point = mapPxToMeter(mapInfo, pointPx);


        }

        return point;
    },

}


/** 实际测绘转地图坐标  开始 **/

/**
 * 实际坐标偏移
 * @param mapInfo
 * @param point
 */
function mapMeterToOffset(mapInfo, point, pointOffsetX, pointOffsetY){
	// if(pointOffsetX < 0) pointOffsetX = 0;
	// if(pointOffsetX > 1) pointOffsetX = 1;
	// if(pointOffsetY < 0) pointOffsetY = 0;
	// if(pointOffsetY > 1) pointOffsetY = 1;
	
    const scaleX = mapInfo.scaleX.split("/");
    const scaleY = mapInfo.scaleY.split("/");
	// 方向：往大里程挖，正；往小里程挖，反
	const direction = mapInfo.direction;
	   
	if(pointOffsetX != 0){
		if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e4'
			|| mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5'
			|| mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e6'
		){
			// 往大里程挖，正；往小里程挖，反
			point.x = point.x + parseFloat(scaleX[1]) * pointOffsetX;
			
		}
    
    }

    if(pointOffsetY != 0){
		if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5'
			|| mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e6'
		){
			// 往大里程挖，正；往小里程挖，反
			if(direction){
				point.y = point.y - parseFloat(scaleY[1]) * pointOffsetY;
				
			}else{
				point.y = point.y + parseFloat(scaleY[1]) * pointOffsetY;
			}
			
		}else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e4'){
			point.y = point.y + parseFloat(scaleY[1]) * pointOffsetY;
		}
    }
    
    return point;
}

/**
 * 地图 米转像素
 * @param mapInfo  地图/区域 信息
 * @param point    地图/区域 坐标
 * @param level 1区域，2地图
 * @return 地图/区域 像素坐标
 */
function mapMeterToPx(mapInfo, point, level = 2){
    // 地图信息
    const startX = mapInfo.startPointX;
    let startY = mapInfo.startPointY;
    const offsetX = mapInfo.offsetX;
    const offsetY = mapInfo.offsetY;
    let startXPx = mapInfo.startPointXPx;
    let startYPx = mapInfo.startPointYPx;
    
    // 无地图比例
    if (!mapInfo.scaleX || !mapInfo.scaleY) {
    	return {xPx: point.x, yPx: point.y};
    }
    
    const scaleX = mapInfo.scaleX.split("/");
    const scaleY = mapInfo.scaleY.split("/");
   
    // 坐标信息
    const x = point.x;
    const y = point.y;

    let xPx = (x - (startX + (level == 2 ? 0 : offsetX))) * parseFloat(scaleX[0]) / parseFloat(scaleX[1]) + startXPx;
    let yPx = (y - (startY + (level == 2 ? 0 : offsetY))) * parseFloat(scaleY[0]) / parseFloat(scaleY[1]) + startYPx;
	
    // 有角度
    if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5'
        || mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e6'
        || mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e2'
    ){
        let tunnelPoints = mapInfo.tunnelPoints.split(';');
        let point1 = tunnelPoints[0].split(",");
        let point2 = tunnelPoints[1].split(",");
        let point4 = tunnelPoints[3].split(",");

        let p1 = {
            x: parseFloat(point1[0]),
            y: parseFloat(point1[1]),
        }
        let p2 = {
            x: parseFloat(point2[0]),
            y: parseFloat(point2[1]),
        }
        let p = {
            x: parseFloat(point4[0]),
            y: parseFloat(point4[1]),
        }

        let p0 = getPointInLine(Math.abs(yPx - startYPx), p1, p, false);
		
		// x 像素偏移	
		const offset_x = getOffsetX(p0, p1, p2);
        if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5'
            || mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e6'
        ){
            // 方向
            const direction = mapInfo.direction;
            // 方向： true大里程，y是负，x偏正； false小里程， y是正，x偏负；
            if(direction){
                if(yPx - startYPx > 0){
                    xPx -= offset_x;

                }else{
                    xPx += offset_x;
                }

            }else{
                if(yPx - startYPx > 0){
                    xPx -= offset_x;

                }else{
                    xPx += offset_x;
                }
            }
        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e2'){
            xPx -= offset_x;
        }

    }
    
    return {
        xPx: xPx,
        yPx: yPx
    };
}

/**
 * 旋转地图坐标
 * @param mapInfo
 * @param pointPx
 * @return {{yPx: undefined, xPx: undefined}}
 */
function spinPointToMap(mapInfo, pointPx) {

    // 坐标集合
    const tunnelPoints = mapInfo.tunnelPoints.split(";");
    const point0 = tunnelPoints[0].split(",");
    const point1 = tunnelPoints[1].split(",");
	
	// 工厂
	const factoryFlag = mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e2';
    // 第二个点的相对坐标
    const w = factoryFlag ? Math.abs(parseFloat(point1[0]) - parseFloat(point0[0])) : (parseFloat(point1[0]) - parseFloat(point0[0]));
    const h = factoryFlag ? Math.abs(parseFloat(point1[1]) - parseFloat(point0[1])) : (parseFloat(point1[1]) - parseFloat(point0[1]));

    // 要旋转的相对坐标
    const x = pointPx.xPx - parseFloat(point0[0]);
    const y = pointPx.yPx - parseFloat(point0[1]);

    // 斜边长度
    const d = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2) );

    let angle0 = Math.atan2(h, w) * 180.0 / Math.PI;
    let angle1 = Math.atan2(y, x) * 180.0 / Math.PI;

    // 求旋转角度
    let angle = angle1 - (360 - angle0);
	
    // 求旋转后的坐标
    const xPx = d * Math.cos(angle / 180.0 * Math.PI) + parseFloat(point0[0]);
    const yPx = d * Math.sin(angle / 180.0 * Math.PI) + parseFloat(point0[1]);

    return {xPx: xPx, yPx: yPx};
}


/** 测绘坐标 转 地图坐标  结束 **/



/** 地图坐标 转 测绘坐标 开始 **/

/**
 * 像素转米 ： 电子围栏实用
 * @param mapInfo 地图信息
 * @param point 像素坐标
 * @param level 1区域，2地图
 * @return 地图/区域 实际坐标
 */
function mapPxToMeter(mapInfo, point, level = 2) {
    // 地图信息
    let startX = mapInfo.startPointX;
    let startY = mapInfo.startPointY;
    const offsetX = mapInfo.offsetX;
    const offsetY = mapInfo.offsetY;
    let startXPx = mapInfo.startPointXPx;
    let startYPx = mapInfo.startPointYPx;
    
    // 无地图比例
    if (!mapInfo.scaleX || !mapInfo.scaleY) {
    	return {x: point.xPx, y: point.yPx};
    }
    
    const scaleX = mapInfo.scaleX.split("/");
    const scaleY = mapInfo.scaleY.split("/");

    // 坐标信息
    let xPx = point.xPx;
    const yPx = point.yPx;

    let x = (xPx - startXPx) / parseFloat(scaleX[0]) * parseFloat(scaleX[1]) + startX + (level == 2 ? 0 : offsetX);
    let y = (yPx - startYPx) / parseFloat(scaleY[0]) * parseFloat(scaleY[1]) + startY + (level == 2 ? 0 : offsetY);

    // 有角度
    if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5'
        || mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e6'
        || mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e2'
    ) {

        let tunnelPoints = mapInfo.tunnelPoints.split(';');
        let point1 = tunnelPoints[0].split(",");
        let point2 = tunnelPoints[1].split(",");
        let point4 = tunnelPoints[3].split(",");

        let p1 = {
            x: parseFloat(point1[0]),
            y: parseFloat(point1[1]),
        }
        let p2 = {
            x: parseFloat(point2[0]),
            y: parseFloat(point2[1]),
        }
        let p = {
            x: parseFloat(point4[0]),
            y: parseFloat(point4[1]),
        }

        let p0 = getPointInLine(Math.abs(yPx - startYPx), p1, p, false);
	
        // x 像素偏移
        const offset_x = getOffsetX(p0, p1, p2);

        if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5'
            || mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
            // 方向
            const direction = mapInfo.direction;
            // 方向： true大里程，y是负，x偏正； false小里程， y是正，x偏负；
            if (direction) {
                if(yPx - startYPx > 0){
                    xPx += offset_x;

                }else{
                    xPx -= offset_x;
                }

            } else {
                if(yPx - startYPx > 0){
                    xPx += offset_x;

                }else{
                    xPx -= offset_x;
                }
            }
        }else if(mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e2'){
            xPx += offset_x;
        }

        x = (xPx - startXPx) / parseFloat(scaleX[0]) * parseFloat(scaleX[1]) + startX + (level == 2 ? 0 : offsetX);


    }

    return {
        x: x,
        y: y
    }

}


/**
 * 旋转地图坐标
 * @param mapInfo
 * @param pointPx
 * @return {{yPx: undefined, xPx: undefined}}
 */
function spinPointToMeter(mapInfo, pointPx) {

    // 坐标集合
    const tunnelPoints = mapInfo.tunnelPoints.split(";");
    const point0 = tunnelPoints[0].split(",");
    const point1 = tunnelPoints[1].split(",");
	
	// 工厂
	const factoryFlag = mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e2';
    // 第二个点的相对坐标
    const w = factoryFlag ? Math.abs(parseFloat(point1[0]) - parseFloat(point0[0])) : (parseFloat(point1[0]) - parseFloat(point0[0]));
    const h = factoryFlag ? Math.abs(parseFloat(point1[1]) - parseFloat(point0[1])) : (parseFloat(point1[1]) - parseFloat(point0[1]));

    // 要旋转的相对坐标
    const x = pointPx.xPx - parseFloat(point0[0]);
    const y = pointPx.yPx - parseFloat(point0[1]);

    // 斜边长度
    const d = Math.sqrt(Math.pow(x , 2) + Math.pow(y, 2) );

    let angle0 = Math.atan2(h, w) * 180.0 / Math.PI;
    let angle1 = Math.atan2(y, x) * 180.0 / Math.PI;

    // 求旋转角度
    let angle = 360 - (angle0 - angle1);

    // 求旋转后的坐标
    const xPx = d * Math.cos(angle / 180.0 * Math.PI) + parseFloat(point0[0]);
    const yPx = d * Math.sin(angle / 180.0 * Math.PI) + parseFloat(point0[1]);

    return {xPx: xPx, yPx: yPx};
}

/** 地图坐标 转 测绘坐标 结束 **/

/**
 * 求x偏移量：斜边与线段的夹角 0~90
 * @param p0    线段外一点： p1斜边上的点
 * @param p1    线段点1
 * @param p2    线段点2
 * @return {number}
 */
function getOffsetX(p0, p1, p2){
    // 斜边长度
    let line = pointToPoint(p0, p1);
    // 高
    let verticalDistance = getVerticalDistance(p0, p1, p2);
    // 斜边就是高
    if(Math.abs(line - verticalDistance) == 0){
        return 0;
    }
    // 求偏移量
    return Math.sqrt(Math.pow(line,2) - Math.pow(verticalDistance,2));
}

/**
 * 求点到线的垂直距离
 * @param p0    线段外一点
 * @param p1    线段点1
 * @param p2    线段点2
 * @return {number}
 */
function getVerticalDistance(p0, p1, p2){
    // 线段的长度
    let line0 = pointToPoint(p1, p2);

    // 线段外的点到线段两个端点的距离
    let line1 = pointToPoint(p0, p1);
    let line2 = pointToPoint(p0, p2);

    // 是三角形
    if(line0 + line1 > line2 && line0 + line2 > line1 && line1 + line2 > line0){
        //求半周长
        let p = (line0 + line1 + line2)/2;
        // 求三角形的面积
        let s = Math.sqrt(p * (p - line0) * (p - line1) * (p - line2));
        return s * 2 / line0;

    }

    return 0;
}

/**
 * 求两点的距离
 * @param p1    线段点1
 * @param p2    线段点2
 * @return {number}
 */
function pointToPoint(p1, p2){
    let distance = 0;
    if(p1 == null || p2 ==null){
        return distance;
    }
    distance = Math.sqrt(Math.pow((p1.x - p2.x),2) + Math.pow((p1.y - p2.y),2));
    return distance;
}

/**
 * @Description //TODO
 * 获取线段上距离线段起始点距离为targetDistance的点的坐标，targetDistance超过线段长度时返回线段结束点
 * 线段两顶点为p1,p2
 * @Param [targetDistance, p1, p2, between]
 * @return {x: ,y:}
 **/
function getPointInLine(targetDistance, p1, p2, between) {
    // 计算线段的长度
    let distance = pointToPoint(p1, p2);

    if(distance == 0){
        return p1;
    }

    targetDistance = Math.abs(targetDistance);

    // 如果targetDistance超过线段的长度直接返回线段结束点
    if (distance <= targetDistance && between) {
        return p2;
    }

    let w = targetDistance/distance;
    let m = 1-w;

    return {
        x: m * p1.x +  w * p2.x,
        y: m * p1.y + w * p2.y
    };
}

/**
 * @Description //TODO 判断点是否在线上
 * @Author Zhangbin
 * @Date 2020/8/31 19:27
 * @Param [point, p1, p2]
 * @return boolean
 **/
function pointIsOnLine(point, p1, p2) {
    let pdline = false;
    if(point == null || p1 == null || p2 == null) {
        return pdline;
    }
    if((point.x - p1.x) * (p1.y - p2.y) == (p1.x - p2.x) * (point.y - p1.y)) {
        pdline = true;
    }
    return pdline;
}




/**
 * 实际转像素
 * @param mapInfo
 * @param point
 positionArea = {
        mapType: mapType
        number: number,
        width: width,
        realPoints: realAreaPoints,
        mapPoints1: mapPoints1,
        mapPoints2: mapPoints2
        realAreaPoints: realAreaPoints,
        mapAreaPoints: mapAreaPoints
    }
 */
function customMadeTunnelToPx(mapInfo, point, offset){
    // 4#斜井, 5号横洞， 6号隧道
    const groupPoints = eval("(" + mapInfo.groupPoints + ")");
    const mapType = mapInfo.mapType;

    let positionArea = {};
    let inRegion = false;
    let i = 0;
    for(i = 0;i<groupPoints.length;i++){
        // 区域坐标
        let areaPoints = parsePointBeans(mapType, groupPoints, i+1);
        if(isInRegion(point, areaPoints.realAreaPoints)){
            inRegion = true;
            Object.assign(positionArea, areaPoints);
            break;
        }
    }
    if(!inRegion){
        let areaPoints = parsePointBeans(mapType, groupPoints, groupPoints.length);
        Object.assign(positionArea, areaPoints);
    }

    // console.log(positionArea)
    let realPoints = positionArea.realPoints;
    i = 0;
    while (i < realPoints.length-1){
        if(positionArea.number == 1){
            if(point.y >= parseFloat(realPoints[i]) && point.y < parseFloat(realPoints[i + 1])){
                break;
            }
        }else{
            if(point.x >= parseFloat(realPoints[i]) && point.x < parseFloat(realPoints[i + 1])){
                break;
            }
        }
        i++;
    }
    // 真实两点
    let realLineP1 ;
    let realLineP2 ;
    // 地图线坐标
    let mapLine1P1 ;
    let mapLine1P2 ;
    let mapLine2P1 ;
    let mapLine2P2 ;
    let mapPoints1 = positionArea.mapPoints1;
    let mapPoints2 = positionArea.mapPoints2;
    if(i == realPoints.length-1){
        realLineP1 = parseFloat(realPoints[realPoints.length-2]);
        realLineP2 = parseFloat(realPoints[realPoints.length-1]);
        mapLine1P1 = mapPoints1[realPoints.length-2].split(",");
        mapLine1P2 = mapPoints1[realPoints.length-1].split(",");
        mapLine2P1 = mapPoints2[realPoints.length-2].split(",");
        mapLine2P2 = mapPoints2[realPoints.length-1].split(",");
    }else{
        realLineP1 = parseFloat(realPoints[i]);
        realLineP2 = parseFloat(realPoints[i+1]);
        mapLine1P1 = mapPoints1[i].split(",");
        mapLine1P2 = mapPoints1[i+1].split(",");
        mapLine2P1 = mapPoints2[i].split(",");
        mapLine2P2 = mapPoints2[i+1].split(",");
    }

    // 地图上两点距离
    let mapLine1D = pointToPoint(
        {x: parseFloat(mapLine1P1[0]), y: parseFloat(mapLine1P1[1])},
        {x: parseFloat(mapLine1P2[0]), y: parseFloat(mapLine1P2[1])}
    );
    let mapLine2D = pointToPoint(
        {x: parseFloat(mapLine2P1[0]), y: parseFloat(mapLine2P1[1])},
        {x: parseFloat(mapLine2P2[0]), y: parseFloat(mapLine2P2[1])}
    );

    if(positionArea.number == 1){
        // x不变，y变
        let scale = Math.abs(point.y - realLineP1) / Math.abs(realLineP2 - realLineP1);
        // console.log(point, realLineP1, realLineP2, scale)
        let mapLine1DY = mapLine1D * scale;
        let mapLine2DY = mapLine2D * scale;

        // console.log(mapLine1D, mapLine2D)

        // 得线上的X，Y坐标
        let mapLine1XY = getPointInLine(mapLine1DY,
            {x: parseFloat(mapLine1P1[0]), y: parseFloat(mapLine1P1[1])},
            {x: parseFloat(mapLine1P2[0]), y: parseFloat(mapLine1P2[1])}, true);
        let mapLine2XY = getPointInLine(mapLine2DY,
            {x: parseFloat(mapLine2P1[0]), y: parseFloat(mapLine2P1[1])},
            {x: parseFloat(mapLine2P2[0]), y: parseFloat(mapLine2P2[1])}, true);

        if(offset == 0){
            return {
                xPx: mapLine1XY.x,
                yPx: mapLine1XY.y
            };
        }
        if(offset == 1 ){
            return {
                xPx: mapLine2XY.x,
                yPx: mapLine2XY.y
            };
        }
        
        let distancePx = pointToPoint(mapLine1XY, mapLine2XY);
    
        let xy = getPointInLine(distancePx * Math.abs(offset), mapLine1XY, mapLine2XY, true);
        return {
            xPx: xy.x,
            yPx: xy.y
        }

    }else{
        // x变，y不变
        let scale = Math.abs(point.x - realLineP1) / Math.abs(realLineP2 - realLineP1);
        let mapLine1DX = mapLine1D * scale;
        let mapLine2DX = mapLine2D * scale;

        // 得线上的X，Y坐标
        let mapLine1XY = getPointInLine(mapLine1DX,
            {x: parseFloat(mapLine1P1[0]), y: parseFloat(mapLine1P1[1])},
            {x: parseFloat(mapLine1P2[0]), y: parseFloat(mapLine1P2[1])}, true);
        let mapLine2XY = getPointInLine(mapLine2DX,
            {x: parseFloat(mapLine2P1[0]), y: parseFloat(mapLine2P1[1])},
            {x: parseFloat(mapLine2P2[0]), y: parseFloat(mapLine2P2[1])}, true);

        if(offset == 0){
            return {
                xPx: mapLine1XY.x,
                yPx: mapLine1XY.y
            };
        }
        if(offset == 1 ){
            return {
                xPx: mapLine2XY.x,
                yPx: mapLine2XY.y
            };
        }
        let distancePx = pointToPoint(mapLine1XY, mapLine2XY);
        
        let xy = getPointInLine(distancePx * Math.abs(offset), mapLine1XY, mapLine2XY, true);
        return {
            xPx: xy.x,
            yPx: xy.y
        }
    }

}

/**
 * 转换成坐标集合
 * @param mapType
 * @param groupPoints
 * @param number
 * @return {{number: *, mapAreaPoints: [], width: *, mapType: *, realPoints: *|string[], realAreaPoints: [], mapPoints1: *|string[], mapPoints2: *|string[]}}
 */
function parsePointBeans(mapType, groupPoints, number){
    // 隧道宽度
    let width = groupPoints[number-1].width;
    // 真实坐标
    let realPoints = groupPoints[number-1].realPoints.split(';');
    // 地图坐标1
    let mapPoints1 = groupPoints[number-1].mapPoints1.split(';');
    // 地图坐标2
    let mapPoints2 = groupPoints[number-1].mapPoints2.split(';');
    // 真实的区域坐标
    let realAreaPoints = [];
    // 地图的区域坐标
    let mapAreaPoints = [];
    let i = 0;
    if(number == 1){
        // 真实坐标
        for(i=0;i<realPoints.length;i++){
            realAreaPoints.push({x: 0, y: parseFloat(realPoints[i])})
        }
        for(i=realPoints.length-1;i>=0;i--){
            realAreaPoints.push({x: Math.abs(parseFloat(width)), y: parseFloat(realPoints[i])})
        }
        realAreaPoints.push(realAreaPoints[0]);

    }else{
        let realPoints1 = groupPoints[0].realPoints.split(';');
        let y = parseFloat(realPoints1[realPoints1.length-1]);

        for(i=0;i<realPoints.length;i++){
            realAreaPoints.push({x: parseFloat(realPoints[i]), y: y})
        }
        for(i=realPoints.length-1;i>=0;i--){
            realAreaPoints.push({x: parseFloat(realPoints[i]), y:  y + Math.abs(parseFloat(width))})
        }
        realAreaPoints.push(realAreaPoints[0]);
    }

    // 地图坐标
    for(i = 0;i < mapPoints1.length; i++){
        let mapPointsXY = mapPoints1[i].split(",");
        // 地图区域坐标
        mapAreaPoints.push({x: parseFloat(mapPointsXY[0]), y: parseFloat(mapPointsXY[1])});
    }
    for(i = mapPoints2.length - 1;i >= 0; i--){
        let mapPointsXY = mapPoints2[i].split(",");
        // 地图区域坐标
        mapAreaPoints.push({x: parseFloat(mapPointsXY[0]), y: parseFloat(mapPointsXY[1])});
    }
    mapAreaPoints.push(mapAreaPoints[0]);


    let positionArea = {
        mapType: mapType,
        number: number,
        width: width,
        realPoints: realPoints,
        mapPoints1: mapPoints1,
        mapPoints2: mapPoints2,
        realAreaPoints: realAreaPoints,
        mapAreaPoints: mapAreaPoints
    }

    return positionArea;

}

/**
 * 判断是否在区域内
 * @param pCur
 * @param positionBeans
 * @return {boolean}
 */
function isInRegion(pCur, positionBeans){
    // 添加第一个点
    if(positionBeans[0] != positionBeans[positionBeans.length-1]){
        positionBeans.push(positionBeans[0]);
    }

    // 任意多边形有N个顶点
    let nCount = positionBeans.length;
    let nCross = 0;
    for (let i = 0; i < nCount; i++) {
        // 依次取相邻的两个点
        let pStart = positionBeans[i];
        let pEnd = positionBeans[(i + 1) % nCount];

        if(pStart.x == pEnd.x && pStart.y == pEnd.y){
        }else{
            if(pointIsOnLine(pCur, pStart, pEnd)){
                return true;
            }
        }

        // 相邻的两个点是平行于x轴的，肯定不相交，忽略
        if (pStart.y == pEnd.y)
            continue;

        // 交点在pStart,pEnd的延长线上，pCur肯定不会与pStart.pEnd相交，忽略
        if (pCur.y < Math.min((pStart.y), pEnd.y)
            || pCur.y > Math.max(pStart.y, pEnd.y))
            continue;

        // 求当前点和x轴的平行线与pStart,pEnd直线的交点的x坐标
        let x = (pCur.y - pStart.y) * (pEnd.x - pStart.x)
            / (pEnd.y - pStart.y) + pStart.x ;

        // 若x坐标大于当前点的坐标，则有交点
        if (x >= pCur.x)
            nCross++;
    }
    // 单边交点为偶数，点在多边形之外
    return (nCross % 2 == 1);

}


/**
 * @Description //TODO 判断点是否在线上
 * @Author Zhangbin
 * @Date 2020/8/31 19:27
 * @Param [point, p1, p2]
 * @return boolean
 **/
function pointIsOnLine(point, p1, p2) {
    let pdline = false;
    if(point == null || p1 == null || p2 == null) {
        return pdline;
    }
    if((point.x - p1.x) * (p1.y - p2.y) == (p1.x - p2.x) * (point.y - p1.y)) {
        pdline = true;
    }
    return pdline;
}


// WEBPACK FOOTER //
// ./src/global/global-map.js